import { distance } from "./distance"

export function followPath(
  { subject, path, speed = 0.09, target = null, directRadius = 200 },
  time,
) {
  if (target && directRadius) {
    const d = distance(subject.x, subject.y, target.x, target.y)
    if (d <= directRadius) {
      directToTarget({ subject, target, speed, time })
      return
    }
  }

  if (path.nodes?.length) {
    const closestNodeIndex = path.nodes.reduce((closest, node, idx) => {
      const r = Math.sqrt(
        Math.pow(node[0] - subject.y, 2) + Math.pow(node[1] - subject.x, 2),
      )
      return !closest || r < closest.r ? { r, idx } : closest
    }, null)?.idx

    if (closestNodeIndex < path.nodes.length - 2) {
      const nextNode = path.nodes[closestNodeIndex + 1]

      const angleToTarget = Math.atan2(
        nextNode[0] - subject.y,
        nextNode[1] - subject.x,
      )

      subject.velocity.x += Math.cos(angleToTarget) * speed * time.deltaTime
      subject.velocity.y += Math.sin(angleToTarget) * speed * time.deltaTime
    }
  } else if (target) directToTarget({ subject, target, speed, time })
}

function directToTarget({ subject, target, speed, time }) {
  const angleToTarget = Math.atan2(target.y - subject.y, target.x - subject.x)

  subject.velocity.x += Math.cos(angleToTarget) * speed * time.deltaTime
  subject.velocity.y += Math.sin(angleToTarget) * speed * time.deltaTime
}
